import { render } from "./governance.vue?vue&type=template&id=f7a3d182"
import script from "./governance.vue?vue&type=script&lang=js"
export * from "./governance.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__